import { ILMapLayer } from '../LMap';
export class TopoLayer implements ILMapLayer {
    public url: string = 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png';
    public attribution: string = 'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors,' +
        ' <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a>' +
        ' (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)';
}
